import React from 'react';
import styles from './DesktopPrizeGallery.module.css';

export type PrizeImageItem = {
  id: string;
  image: React.ReactNode;
  altText?: string;
};

export function DesktopPrizeGallery({ items }: { items: PrizeImageItem[] }) {
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const filledItems = React.useMemo(() => {
    return items.slice(0, 5);
  }, [items]);

  // Thumbnails are the 4 non-selected images for the 2x2 grid
  const thumbnailIndices = React.useMemo(() => {
    return filledItems
      .map((_, idx) => idx)
      .filter((idx) => idx !== selectedIndex)
      .slice(0, 4);
  }, [filledItems, selectedIndex]);

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.mainImageFrame}>
          {filledItems[selectedIndex]?.image}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.thumbnailGrid} role="list">
          {thumbnailIndices.map((idx) => {
            const item = filledItems[idx];
            return (
              <button
                key={item.id}
                role="listitem"
                className={`${styles.thumbnail} ${idx === selectedIndex ? styles.thumbnailActive : ''}`}
                onClick={() => setSelectedIndex(idx)}
                aria-label={`View image ${idx + 1}`}
              >
                <div className={styles.thumbnailFrame}>{item.image}</div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
